
import React, { useContext, useEffect, useState } from "react";
import { Button, Collapse, Tab, Tabs } from "react-bootstrap";
import { withTranslation, useTranslation } from 'react-i18next';
import { LoaderContext, RegulationContext } from '../../../App';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import PaginationComponent from "../../../components/Pagination/Pagination";
import ReportingPeriod from "../../../components/Regulation/ReportingPeriod";
import { DEFAULT_ITEMS_PER_PAGE } from "../../../core/constants/common";
import GeneralDisclosureService from "../../../core/service/GeneralDisclosureService";
import CompanyQuestionContainer from "./CompanyQuestionContainer";
import GDQuestionFormPopup from "../../Common/Disclosures/GDQuestionFormPopup";
import { BiChevronDown, BiX } from 'react-icons/bi';
import { CgSortAz } from "react-icons/cg";
import AppFilter from "../../../components/AppFilter/AppFilter";
import QuestionService from "../../../core/service/QuestionService";

const GeneralDisclosure = ({ t, embeddedView, yearFilter, reportingPeriod, onDataUpdate, activeView, onHelpTextCallback }) => {
  const { glbRegulation } = useContext(RegulationContext);
  const year = new Date().getFullYear();

  const [questions, setQuestions] = useState([]);
  const [showSaveConfirm, setShowSaveConfirm] = useState(false);
  const [tabsToRender, setTabsToRender] = useState([]);
  const [answers, setAnswers] = useState({});
  const [activeHelpText, setActiveHelpText] = useState('');
  const [activeTab, setActiveTab] = useState('');
  const [period, setPeriod] = useState(`${yearFilter ?? year}-01-01`);
  const { setLoaderDisplay } = useContext(LoaderContext);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [pgn, setPgn] = useState(0);
  const [questionModalVis, setQuestionModalVis] = useState(false);
  const { k, i18n } = useTranslation();
  useEffect(() => {
    if (glbRegulation.id) {
      setQuestions([]);
      getCategory();
    }
  }, [glbRegulation.id]);

  useEffect(() => {
    if (!activeTab || !period) return;

    getDisclosureQuestionsAndAnswers(activeTab, period, 1, DEFAULT_ITEMS_PER_PAGE);
  }, [activeTab, period]);

  useEffect(() => {
    setPeriod(reportingPeriod);
  }, [reportingPeriod])

  const getCategory = async () => {
    try {
      const response = await GeneralDisclosureService.getStandardTypes();
      const categoryData = response.data;
      const griCategories = [];
      categoryData?.forEach(category => {
        if (!category.disclosure?.questionCount) return;

        griCategories.push({
          categoryTypeName: category.categoryType,
          categoryType: category.categoryType,
          questionCount: category.disclosure.questionCount,
        });
      });
      setTabsToRender(griCategories);
      if (!embeddedView) return;

      setActiveTab(activeView ? activeView : griCategories[0].categoryType);
    } catch (error) {
    }
  };
  const getDisclosureQuestionsAndAnswers = (cat, p, pageNumber, itemsPerPageVal) => {
    setLoaderDisplay(true);
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    let perPage;
    if (itemsPerPageVal > 0) {
      perPage = itemsPerPageVal;
    } else {
      perPage = itemsPerPage;
    }
    GeneralDisclosureService.getPagedQuestionsAndAnswers(cat, p, pageNumber, perPage)
      .then((response) => {
        setLoaderDisplay(false);
        setPgn(pageNumber)
        const totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        if (response.status !== 200) return;

        initializeAnswers(response.data ?? []);
        setQuestions(response.data ?? []);
      })
      .catch((error) => {
        setLoaderDisplay(false);
      });
  };
  const initializeAnswers = (questions) => {
    const initialAnswers = {};
    questions?.forEach(question => {
      if (question.children?.length > 0) {
        question?.children?.forEach(childQuestion => {
          const ans = [];
          if (childQuestion.answers?.length > 0) {
            childQuestion.answers
              ?.sort((a, b) => +(a.cell) - +(b.cell))
              ?.forEach(answer => {
                ans.push({
                  id: answer.id,
                  answer: answer.answer,
                  cell: answer.cell ?? '1',
                  remark: answer.remark,
                  attachments: answer.attachments
                });
              });
          } else {
            ans.push({ id: 0, answer: '', cell: '1' });
          }
          initialAnswers[childQuestion.id] = ans;
        });
      } else {
        const ans = [];
        if (question.answers?.length > 0) {
          question.answers
            ?.sort((a, b) => +(a.cell) - +(b.cell))
            ?.forEach(answer => {
              ans.push({
                id: answer.id,
                answer: answer.answer,
                cell: answer.cell  ?? '1',
                remark: answer.remark,
                attachments: answer.attachments
              });
            });
        } else {
          ans.push({ answer: '', cell: '1' });
        }
        initialAnswers[question.id] = ans;
      }
    });
    setAnswers(initialAnswers);
  };

  const handleSelect = (key) => {
    setActiveTab(key);
  };


  const renderQuestionHelpTextContainer = () => {
    if (!activeHelpText) return <></>;

    const lines = activeHelpText.helpText.split('\n');
    const paras = [];

    lines.forEach((line) => {
      //checks for roman numeral followed by dot present,if present put padding there,
      if (/^\s*([ivxlmIVXLCDM]+)\./.test(line)) {
        paras.push(<p className='mt-0 mb-0 px-4'>{line}</p>);
      } else if (/^\s*[a-zA-Z]+\./.test(line)) {
        paras.push(<p className='mt-0 mb-0 px-2'>{line}</p>);
      } else {
        paras.push(<p className='mt-0 mb-0'>{line}</p>);
      }
    });

    return (
      <div className='col-md-4 p-2'>

        <div
          className="card p-2 border-primary"
          style={{ marginTop: embeddedView ? `${activeHelpText?.top} mx-4` : activeHelpText?.top }}
        >
          <h6><b>{t("HelpText.label")}</b></h6>
          <p>{lines}</p>
          {!activeHelpText.sampleAnswer && activeHelpText.sampleAnswer!=undefined &&
            <div>
              <h6><b>{t("SampleAnswer.label")}</b></h6>
              <p>{activeHelpText.sampleAnswer}</p>
            </div>
          }

        </div>
      </div>
    );
  };

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleDiv = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle between true and false
  };

  const renderEmbeddedView = () => {
    return (
      <div className="GeneralDisclosure">
        <div className="List_header">
          <div><h5 className="MH">{t("GeneralDisclosure.label")}</h5></div>
          <div className="d-flex justify-content-end align-items-center header-actions">
            <Button className="btn btn-secondary" onClick={toggleDiv}>
              <CgSortAz /> Filter
            </Button>
          </div>
        </div>
        <div className="row m-0 GeneralDisclosure_row">
          <div className={`p-0 ${embeddedView ? 'col-lg-8' : 'col-md-8'}`}>
            <div className="">
              {
                tabsToRender.length > 0 &&
                <Tabs
                  defaultActiveKey={activeView ? activeView : (tabsToRender[0].categoryType)}
                  id="uncontrolled-tab-example"
                  className="GeneralDisclosure-tab"
                  onSelect={(k) => handleSelect(k)}>
                  {
                    tabsToRender.map((tab, index) => (
                      <Tab key={index}
                        eventKey={tab.categoryType}
                        title={tab.categoryType}>
                        <div className="NewQuestion_btn">
                          <Button variant="primary"  onClick={() => setQuestionModalVis(true)}>
                            {t("NewQuestion.label")}
                          </Button>
                        </div>
                        {isFilterVisible &&
                          <AppFilter
                            type={'GD'}
                            existingFilter={{ period }}
                            onApplyFilter={(f) => { setPeriod(f.period); getDisclosureQuestionsAndAnswers(activeTab, f.period, 1, DEFAULT_ITEMS_PER_PAGE); }}
                            onFilterHide={(value) => setIsFilterVisible(value)} />
                        }

                        <div className="card">
                          <div className="card-body px-1">
                            <div>
                              <div>
                                {
                                  questions?.length > 0 &&
                                  <CompanyQuestionContainer
                                    pgnum={pgn}
                                    ansData={answers}
                                    questions={questions}
                                    type='GENERAL_DISCLOSURE'
                                    filter={{ reportingPeriod: period }}
                                    onDisplayHelpText={(q) => {
                                      if (activeHelpText?.id === q.id) {
                                        setActiveHelpText('');
                                      } else {
                                        setActiveHelpText(q);
                                      }
                                    }}
                                    refreshData={() => {
                                      getDisclosureQuestionsAndAnswers(activeTab, period, currentPage, itemsPerPage);
                                      if (!embeddedView) return;

                                      onDataUpdate();
                                    }} />
                                }
                              </div>
                              {
                                itemsTotalCount > 9 &&
                                <div className="p-2 List_footer_count">
                                  <PaginationComponent
                                    itemsTotalCount={itemsTotalCount}
                                    itemsPerPage={itemsPerPage}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    alwaysShown={true}
                                    setItemsPerPage={setItemsPerPage}
                                    pageClicked={(pageNum, perPage) => {

                                      getDisclosureQuestionsAndAnswers(activeTab, period, pageNum, perPage);
                                    }}
                                  />
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </Tab>
                    ))}
                </Tabs>
              }
            </div>
          </div>
          {renderQuestionHelpTextContainer()}
        </div>
      </div>
    );
  };

  const renderCollaspibleView = () => {
    return (
      <>
        {
          tabsToRender.map((gd, gdIndex) => {
            return (
              <>
              <div key={`gdGroup-${gdIndex}`} className="card mb-2">
                <div className="Qualitative_qusBox">
                  <span onClick={(e) => setActiveTab(activeTab ? '' : gd.categoryType)}>
                    <BiChevronDown />
                  </span>
                  <h6 className="mb-0" >{t("Disclosures.label") + ' - ' + gd.categoryTypeName}</h6>
                </div>
                <Collapse in={gd.categoryType === activeTab}
                  onExited={() => setActiveHelpText('')}>
                  <div className="card-body p-1 border-top">
                    <div>
                      <div>
                        {
                          questions?.length > 0 &&
                          <CompanyQuestionContainer
                            pgnum={pgn}
                            ansData={answers}
                            questions={questions}
                            type='GENERAL_DISCLOSURE'
                            filter={{ reportingPeriod: period }}
                            onDisplayHelpText={(q) => {
                              if (activeHelpText?.id === q.id) {
                                setActiveHelpText('');
                                onHelpTextCallback('');
                              } else {
                                setActiveHelpText(q);
                                onHelpTextCallback(q);
                              }
                            }}
                            refreshData={() => {
                              getDisclosureQuestionsAndAnswers(activeTab, period, currentPage, itemsPerPage);
                              if (!embeddedView) return;

                              onDataUpdate();
                            }} />
                        }
                        {renderQuestionHelpTextContainer()}
                      
                      </div>
                      {
                        itemsTotalCount > 9 &&
                        <div className="p-2 List_footer_count">
                          <PaginationComponent
                            itemsTotalCount={itemsTotalCount}
                            itemsPerPage={itemsPerPage}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            alwaysShown={true}
                            setItemsPerPage={setItemsPerPage}
                            pageClicked={(pageNum, perPage) => {
                              getDisclosureQuestionsAndAnswers(activeTab, period, pageNum, perPage);
                            }}
                          />
                        </div>
                      }
                    </div>
                  </div>
                </Collapse>
              </div>
              {/* {renderQuestionHelpTextContainer()} */}
              </>
            )
          })
        }
        {/* {renderQuestionHelpTextContainer()} */}
      </>
    );
  };

  return (
    <>
      {embeddedView ? renderEmbeddedView() : renderCollaspibleView()}
      {
        showSaveConfirm &&
        <ConfirmationModal
          modalShow={true}
          messageText="Data saved successfully!"
          callbackModal={() => setShowSaveConfirm(false)}
          confirmBtn="OK" />
      }
      {
        questionModalVis &&
        <GDQuestionFormPopup disclosureId={questions[0].disclosureId}
          question={{ id: 0 }}
          saveCallback={(val) => {
            setQuestionModalVis(false);
            if (val) {
              getDisclosureQuestionsAndAnswers(activeTab, period, currentPage, itemsPerPage);
            }
          }} />
      }
    </>
  );
}

export default withTranslation()(GeneralDisclosure);
